<button
  #trigger
  type="button"
  class="dp-trigger"
  [class.dp-trigger--open]="isOpen()"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  aria-haspopup="dialog"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-label]="('DATE_PICKER.PICK_DATE' | translate) + ' : ' + triggerLabel()"
  (click)="toggle()"
  data-attr="date-picker-trigger">
  <span class="dp-trigger__label">{{ triggerLabel() }}</span>
  <svg class="dp-trigger__chevron" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 6l5 5 5-5" /></svg>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="positions"
  (overlayOutsideClick)="onOutsideClick($event)"
  (overlayKeydown)="$event.key === 'Escape' && close()"
  (detach)="close()">

  <div class="dp-panel" role="dialog" [attr.aria-label]="'DATE_PICKER.PICK_DATE' | translate">

    <div class="dp-header">
      <button
        type="button"
        class="dp-header__arrow"
        [attr.aria-label]="'DATE_PICKER.PREVIOUS' | translate"
        (click)="shift(-1)"
        data-attr="date-picker-prev">
        <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10.5 2.5 5 8l5.5 5.5" /></svg>
      </button>
      <span class="dp-header__title" aria-live="polite">{{ title() }}</span>
      <button
        type="button"
        class="dp-header__arrow"
        [attr.aria-label]="'DATE_PICKER.NEXT' | translate"
        (click)="shift(1)"
        data-attr="date-picker-next">
        <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 2.5 11 8l-5.5 5.5" /></svg>
      </button>
    </div>

    @switch (view()) {
      @case ('day') {
        <table class="dp-days" role="grid">
          <thead>
            <tr>
              @for (weekday of weekdays(); track $index) {
                <th scope="col" class="dp-days__weekday">{{ weekday }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (week of weeks(); track $index) {
              <tr>
                @for (cell of week; track $index) {
                  <td>
                    @if (cell) {
                      <button
                        type="button"
                        class="dp-cell dp-cell--day"
                        [class.dp-cell--selected]="cell.isSelected"
                        [class.dp-cell--today]="cell.isToday"
                        [attr.aria-pressed]="cell.isSelected"
                        [attr.aria-current]="cell.isToday ? 'date' : null"
                        (click)="selectDay(cell)">
                        {{ cell.day }}
                        @if (cell.isMarked) { <span class="dp-cell__dot" aria-hidden="true"></span> }
                      </button>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
      @case ('month') {
        <div class="dp-periods">
          @for (month of months(); track month.value) {
            <button
              type="button"
              class="dp-cell dp-cell--period"
              [class.dp-cell--selected]="month.isSelected"
              [attr.aria-pressed]="month.isSelected"
              (click)="selectMonth(month.value)">
              {{ month.label }}
              @if (month.isMarked) { <span class="dp-cell__dot" aria-hidden="true"></span> }
            </button>
          }
        </div>
      }
      @case ('year') {
        <div class="dp-periods">
          @for (year of years(); track year.value) {
            <button
              type="button"
              class="dp-cell dp-cell--period"
              [class.dp-cell--selected]="year.isSelected"
              [attr.aria-pressed]="year.isSelected"
              (click)="selectYear(year.value)">
              {{ year.label }}
              @if (year.isMarked) { <span class="dp-cell__dot" aria-hidden="true"></span> }
            </button>
          }
        </div>
      }
    }

    <div class="dp-footer">
      <button
        type="button"
        class="dp-box dp-box--day"
        [class.dp-box--active]="view() === 'day'"
        [attr.aria-pressed]="view() === 'day'"
        [attr.aria-label]="'DATE_PICKER.DAY' | translate"
        (click)="setView('day')"
        data-attr="date-picker-day">
        {{ dayLabel() ?? ('DATE_PICKER.DAY' | translate) }}
      </button>
      <span class="dp-footer__sep" aria-hidden="true">/</span>
      <button
        type="button"
        class="dp-box dp-box--month"
        [class.dp-box--active]="view() === 'month'"
        [attr.aria-pressed]="view() === 'month'"
        [attr.aria-label]="'DATE_PICKER.MONTH' | translate"
        (click)="setView('month')"
        data-attr="date-picker-month">
        {{ monthLabel() ?? ('DATE_PICKER.MONTH' | translate) }}
      </button>
      <span class="dp-footer__sep" aria-hidden="true">/</span>
      <button
        type="button"
        class="dp-box dp-box--year"
        [class.dp-box--active]="view() === 'year'"
        [attr.aria-pressed]="view() === 'year'"
        [attr.aria-label]="'DATE_PICKER.YEAR' | translate"
        (click)="setView('year')"
        data-attr="date-picker-year">
        {{ draftYear() ?? ('DATE_PICKER.YEAR' | translate) }}
      </button>
      <button
        type="button"
        class="dp-confirm"
        [disabled]="!canConfirm()"
        (click)="confirm()"
        data-attr="date-picker-confirm">
        {{ 'DATE_PICKER.CONFIRM' | translate }}
      </button>
    </div>

  </div>
</ng-template>
